// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AfwN","question":"styles_question__1jbc1","description":"styles_description__Vbn96"};